// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__2JGRB","title":"card_title__ANbE1","size":"card_size__1pCnD","nsfw":"card_nsfw__3zrOe"};